module.exports = __webpack_public_path__ + "img/Logo_traction.d7631a0b.svg";